export const AZURE_DEVOPS = "Azure DevOps";
export const DEVOPS_AND_AZURE = "DevOps and Cloud";
export const DEVOPS_EXPERT = "DevOps";
export const AZURE_DEVOPS_HEADING = "Cloud";
export const GENAI = "GenAI";
export const MASTER_PROGRAM = "Master Online Program";
export const DEVOPS_CERTIFICATION = "DevopsCertification";
export const EXECUTIVE_PG_DEVOPS_PROGRAM = "Online DevOps Course with Multi-Cloud & Gen AI - Job Ready Program";
export const EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT = "Online DevOps Course with Multi-Cloud & Gen AI - Job Ready Program Short";
export const DEVOPS_AND_CLOUD_PROGRAM = "DevOps & Cloud with GenAI Job-Ready Program";
export const BANGALORE = "Bangalore";
export const HYDERABAD = "Hyderabad";
export const PUNE = "Pune";
export const CHENNAI = "Chennai";
export const MUMBAI = "Mumbai";
export const DELHI = "Delhi";
export const DELHI_NCR = "Delhi-NCR";
export const DATA_SCIENCE = "Data Science";